import { render, staticRenderFns } from "./BarChartCard.vue?vue&type=template&id=90481436"
import script from "./BarChartCard.vue?vue&type=script&lang=js"
export * from "./BarChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports